import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ForwardRegular from './forward-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ForwardRegular {...validProps} />;
}
SvgComponent.iconName = 'forwardRegular';

export const ForwardRegularIcon = svgIconWrapper(SvgComponent);
